import { Alert } from "antd";
import { Checkbox, Modal, Select, Timeline } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import { config } from "~/config.js";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";

const modalSuccess = (club, email) => {
  Modal.success({
    title: $t("Club toegevoegd"),
    content: (
      <div>
        <p>
          {$t("Je aanvraag voor gastvlieger is verstuurd")}
        </p>

        <p>
          <span className="bold" style={{ marginRight: 6, fontSize: 16 }}>
            1.
          </span>
          {$t("De aanvraag ligt ter goedkeuring bij de club")}
        </p>
        <p className="small" style={{ marginBottom: 24 }}>
          {$t(
            "Neem contact op om het process te versnellen."
          )}
        </p>

        <p>
          <span className="bold" style={{ marginRight: 6, fontSize: 16 }}>
            2.
          </span>
          {$t("Na goedkeuring ontvang je een email")}
        </p>
        <p className="small" style={{ marginBottom: 24 }}>
          {$t(
            "Met verdere instructies om je wachtwoord te kiezen."
          )}
        </p>

        <p>
          <span className="bold" style={{ marginRight: 6, fontSize: 16 }}>
            3.
          </span>
          {$t(
            "Login met je email '${email}' op de ${url} van je gastclub via",
            { email, url: config.frontend_base_url, club: club.club }
          )}{" "}
          <span className="bold">
            {club.club}.{config.frontend_base_url}
          </span>
        </p>
      </div>
    ),
  });
};

export const CardGuestClubAddModal = ({
  visible,
  onClose,
  guest_clubs,
  club,
}) => {
  const [newClub, setClub] = useState(null);
  const [shareOK, setShareOK] = useState(false);
  const [htOK, setHtOK] = useState(false);

  const [clubOptions, setClubOptions] = useState([]);

  // Fetch club options from API or use static data
  useEffect(() => {
    const fetchClubs = async () => {
      const data = await api.get(
        "",
        `${config.base_backend_url}/all/clubs.json`
      );
      const activeClubs = guest_clubs ? guest_clubs.filter((c) => !c.date_deactivated) : []
      
      if (data) {
        const clubList = data
          .filter((c) => c.on_homepage && c.name !== club.name)
          .map((club) => ({
            value: club.schema_name,
            label: `${club.name}: ${club.full_name}`,
            club: club.schema_name,
            full_name: club.full_name,
            disabled: activeClubs?.some((c) => c.club === club.schema_name),
          }));
        setClubOptions(clubList);
      }
    };
    visible && fetchClubs();
  }, [visible]);

  const dispatch = useDispatch();

  const [saving, setSaving] = useState(false);
  const saveClub = async () => {
    setSaving(true);
    const club = clubOptions.find((c) => c.value === newClub);
    const data = await api.post("gegevens/add_guest_club.json", club);

    setSaving(false);

    if (data) {
      dispatch({
        type: "SET_PROFILE",
        profile: data,
      });
      setClub(null);
      setShareOK(false);
      setHtOK(false);
      onClose();
      modalSuccess(club, data.email);
      
    }
  };

  return (
    <Modal
      open={visible}
      title={$t("Voeg gastclub toe")}
      onCancel={onClose}
      footer={[
        <SluitButton key="cancel" onClick={onClose} disabled={saving} />,
        <SaveButton
          key="save"
          onClick={saveClub}
          disabled={!newClub || !shareOK || !htOK}
          loading={saving}
        />,
      ]}
    >
      <Alert
        style={{ marginBottom: 24 }}
        message={$t(
          "Indien je vaker bij een andere club vliegt, kan het handig zijn om jezelf daar aan te melden als gastvlieger. Je profiel en recency worden zichtbaar voor instructeurs, en je kan daarmee je vliegbekwaamheid aantonen. Daar gemaakte vluchten worden elke avond automatisch in je eigen logboek bijgewerkt."
        )}
      />

      <Timeline>
        <Timeline.Item color={club ? "green" : "blue"}>
          <p className="bold">{$t("Selecteer een club")}</p>
          <Select
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            placeholder={$t("Selecteer een club")}
            style={{ width: "100%" }}
            onChange={(value) => setClub(value)}
            value={newClub}
            options={clubOptions}
          />
        </Timeline.Item>

        <Timeline.Item
          style={{ cursor: "pointer" }}
          onClick={() => setShareOK(!shareOK)}
          dot={<Checkbox checked={shareOK} />}
          color={shareOK ? "green" : "blue"}
        >
          <span>
            {$t(
              "Ik ga ermee akkoord dat mijn gegevens worden gedeeld met de geselecteerde club, en dat instructeurs, beheerders en bestuursleden mijn gegevens kunnen inzien."
            )}
          </span>
        </Timeline.Item>

        <Timeline.Item
          style={{ cursor: "pointer" }}
          onClick={() => setHtOK(!htOK)}
          dot={<Checkbox checked={htOK} />}
          color={htOK ? "green" : "blue"}
        >
          <span>
            {$t(
              "Ik ben me ervan bewust dat na deactivering mijn gegevens bij de gastclub nog 3 jaar zichtbaar blijven volgens EASA-vereisten."
            )}
          </span>
        </Timeline.Item>
      </Timeline>
    </Modal>
  );
};
